import _classCallCheck from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import { WobbleSpeed } from "./WobbleSpeed";
import { setRangeValue } from "tsparticles-engine";
export var Wobble = /*#__PURE__*/function () {
  function Wobble() {
    _classCallCheck(this, Wobble);

    this.distance = 5;
    this.enable = false;
    this.speed = new WobbleSpeed();
  }

  _createClass(Wobble, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.distance !== undefined) {
        this.distance = setRangeValue(data.distance);
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.speed !== undefined) {
        if (typeof data.speed === "number") {
          this.speed.load({
            angle: data.speed
          });
        } else {
          var rangeSpeed = data.speed;

          if (rangeSpeed.min !== undefined) {
            this.speed.load({
              angle: rangeSpeed
            });
          } else {
            this.speed.load(data.speed);
          }
        }
      }
    }
  }]);

  return Wobble;
}();